// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jL7J","label":"styles_label__1ulaH"};